import React from "react"
import styled from "styled-components"
import {IntlProvider, FormattedNumber} from "react-intl"

import Flex from "@irati/ui/src/Flex"
import FlexiPointsIcon from "@irati/ui/images/flexi_point.svg"
import RewardPointsIcon from "@irati/ui/images/reward_point.svg"
import {PaymentCurrencyType} from "@irati/types"

import {getNormalisedValue} from "../../currency/formatCurrency"
import getDeviceLocale from "../helpers/getDeviceLocale"

const Image = styled.img`
  margin-right: ${({theme}) => theme.spacing.half};
`

export interface FormattedCurrencyProps extends Omit<FormattedNumber.Props, "value" | "currency"> {
  isCents?: boolean
  value: string | number
  currency: string
  style?: "currency" | "percent" | "number"
}

/** @author: Richard Scoones
 *  @desc: Disabling lint rule for "style" as react-intl (badly) use it for non style stuff
 */
/* eslint-disable react/style-prop-object */

const FormattedCurrency: React.FC<FormattedCurrencyProps> = ({
  isCents = true,
  value,
  currency,
  maximumFractionDigits,
  style = "currency",
  ...props
}) => {
  const decimal = maximumFractionDigits ?? 2
  const normalisedValue = Number(getNormalisedValue(isCents, currency, value).toFixed(decimal))

  switch (currency) {
    case PaymentCurrencyType.Tt:
      return (
        <Flex alignItems="center">
          <Image src={FlexiPointsIcon} alt="Flexi Point Icon" />
          <FormattedNumber {...props} value={normalisedValue} />
        </Flex>
      )
    case PaymentCurrencyType.Rp:
      return (
        <Flex alignItems="center">
          <Image src={RewardPointsIcon} alt="Reward Point Icon" />
          <FormattedNumber {...props} value={normalisedValue} />
        </Flex>
      )
    default:
      return (
        <IntlProvider locale={getDeviceLocale()}>
          <FormattedNumber
            {...props}
            style={style}
            currency={currency}
            value={normalisedValue}
            maximumFractionDigits={maximumFractionDigits}
          />
        </IntlProvider>
      )
  }
}

export default FormattedCurrency
